import { LevelSpecification } from '../../LevelSpecification';
import { BasementLevelSpecification } from '../../BasementLevelSpecification';

export const isBasementLevel = (level: LevelSpecification): level is BasementLevelSpecification =>
  level.level < 0;
